import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Plus, Edit, Trash2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "../../components/ui/dialog";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../i18n/LanguageContext";
import DatabaseLocationInput from '../../components/DatabaseLocationInput';
import {RequirementsEditor} from '../../components/VisaRequirements';
import CurrencySelect from '../../components/CurrencySelect';
import {visaTypes} from '../../components/visaTypes';
const API = "/api/records.php?resource=visas";
const initialForm = {
  name_ar: "",
  name_en: "",
  country: "",
  country_flag: "",
  visa_type: "tourist",
  duration: "",
  processing_time: "",
  price: "",
  currency: ""
};
export default function VisasPage() {
  __useLocale();
  const {
    token
  } = useAuth();
  const {
    t
  } = useLanguage();
  const [visas, setVisas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(initialForm);
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  };
  useEffect(() => {
    if (token) fetchVisas();
  }, [token]);
  const fetchVisas = async () => {
    setErrorMessage('');
    try {
      setLoading(true);
      const res = await axios.get(API, {
        headers
      });
      setVisas(res.data || []);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || "تعذر تنفيذ العملية");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const resetForm = () => {
    setForm(initialForm);
    setEditing(null);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      ...form,
      price: form.price ? parseFloat(form.price) : 0,
      requirements_json: JSON.stringify(form.requirements || [])
    };
    try {
      if (editing) {
        await axios.put(`${API}&id=${encodeURIComponent(editing.id)}`, payload, {
          headers
        });
      } else {
        await axios.post(API, payload, {
          headers
        });
      }
      resetForm();
      setOpen(false);
      fetchVisas();
    } catch (err) {
      setErrorMessage(err.response?.data?.message || "تعذر حفظ التأشيرة");
      console.error(err);
    }
  };
  const handleEdit = visa => {
    setEditing(visa);
    setForm({
      ...visa,
      requirements: JSON.parse(visa.requirements_json || '[]'),
      price: visa.price || ""
    });
    setOpen(true);
  };
  const handleDelete = async id => {
    if (!window.confirm(t("visa.Delete_this_visa"))) return;
    try {
      await axios.delete(`${API}&id=${encodeURIComponent(id)}`, {
        headers
      });
      fetchVisas();
    } catch (err) {
      setErrorMessage(err.response?.data?.message || "تعذر حذف التأشيرة");
      console.error(err);
    }
  };
  return <div className="space-y-6">
      {__tr(errorMessage && <p role="alert" className="text-red-700">{__tr(errorMessage)} <button onClick={fetchVisas}>{__tr("إعادة التحميل")}</button></p>)}

      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">{__tr(t("visa.Visa_Services"))}</h1>

        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button onClick={resetForm} className="bg-[#6B5B95] hover:bg-[#5B4B85]">
              <Plus className="w-4 h-4 ml-2" />
              {__tr(t("visa.Add_Visa"))}
            </Button>
          </DialogTrigger>

          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {__tr(editing ? t("visa.Edit_Visa") : t("visa.Add_Visa"))}
              </DialogTitle>

              <DialogDescription>
                {__tr(t("visa.Fill_the_form_below_to"))}{__tr(" ")}
                {__tr(editing ? t("visa.Update") : t("visa.create"))}{__tr(" ")}
                {__tr(t("visa.Visa_Services"))}
              </DialogDescription>
            </DialogHeader>

            <form onSubmit={handleSubmit} className="space-y-4">

              <Input placeholder={__tr(t("visa.Arabic_Name"))} value={form.name_ar} onChange={e => setForm({
              ...form,
              name_ar: e.target.value
            })} required />

              <Input placeholder={__tr(t("visa.English_Name"))} value={form.name_en} onChange={e => setForm({
              ...form,
              name_en: e.target.value
            })} required />

              <DatabaseLocationInput kind="visa" placeholder={__tr(t("visa.Country"))} value={form.country} onChange={e => setForm({
              ...form,
              country: e.target.value
            })} required />

              <label className="block">{__tr('نوع التأشيرة')}<select className="w-full border rounded p-2" required value={form.visa_type} onChange={e=>setForm({...form,visa_type:e.target.value})}>{!visaTypes[form.visa_type]&&form.visa_type&&<option value={form.visa_type}>{form.visa_type}</option>}{Object.entries(visaTypes).map(([key,label])=><option key={key} value={key}>{__tr(label)}</option>)}</select></label>
              <Input placeholder={__tr(t("visa.Duration"))} value={form.duration} onChange={e => setForm({
              ...form,
              duration: e.target.value
            })} />

              <Input placeholder={__tr(t("visa.Processing_Time"))} value={form.processing_time} onChange={e => setForm({
              ...form,
              processing_time: e.target.value
            })} />

              <Input aria-label="Duration (English)" placeholder={__tr("مدة التأشيرة بالإنجليزية")} value={form.duration_en || ''} onChange={e => setForm({
              ...form,
              duration_en: e.target.value
            })} />
              <Input aria-label="Processing time (English)" placeholder={__tr("مدة الإنجاز بالإنجليزية")} value={form.processing_time_en || ''} onChange={e => setForm({
              ...form,
              processing_time_en: e.target.value
            })} />
              <Input type="number" placeholder={__tr(t("visa.Price"))} value={form.price} onChange={e => setForm({
              ...form,
              price: e.target.value
            })} />

              <label className="block">{__tr("العملة")}<CurrencySelect required value={form.currency} onChange={e => setForm({
                ...form,
                currency: e.target.value
              })} /></label>
              <RequirementsEditor value={form.requirements || []} onChange={requirements => setForm({...form,requirements})} />
              <Button type="submit" className="w-full">
                {__tr(editing ? t("visa.Update") : t("visa.Save"))}
              </Button>

            </form>
          </DialogContent>
        </Dialog>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        {__tr(loading ? <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6B5B95]"></div>
          </div> : <div className="overflow-x-auto">

            <table className="w-full">

              <thead>
                <tr className="border-b">
                  <th className="text-right py-3 px-4 text-gray-600">{__tr("ID")}</th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.Country"))}
                  </th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.Arabic_Name"))}
                  </th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.English_Name"))}
                  </th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.Duration"))}
                  </th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.Price"))}
                  </th>
                  <th className="text-right py-3 px-4 text-gray-600">
                    {__tr(t("visa.Actions"))}
                  </th>
                </tr>
              </thead>

              <tbody>
                {__tr(visas.map(v => <tr key={v.id} className="border-b hover:bg-gray-50">

                    <td className="py-3 px-4 text-sm font-mono">{__tr(v.id)}</td>

                    <td className="py-3 px-4 text-sm">{__tr(v.country)}</td>

                    <td className="py-3 px-4 text-sm">{__tr(__localizedField(v, "name_ar"))}</td>

                    <td className="py-3 px-4 text-sm">{__tr(v.name_en)}</td>

                    <td className="py-3 px-4 text-sm">{__tr(v.duration)}</td>

                    <td className="py-3 px-4 text-sm">
                      {__tr(v.price)} {__tr(v.currency)}
                    </td>

                    <td className="py-3 px-4">
                      <div className="flex gap-2">

                        <Button size="sm" variant="ghost" onClick={() => handleEdit(v)}>
                          <Edit className="w-4 h-4" />
                        </Button>

                        <Button size="sm" variant="ghost" onClick={() => handleDelete(v.id)}>
                          <Trash2 className="w-4 h-4 text-red-500" />
                        </Button>

                      </div>
                    </td>

                  </tr>))}
              </tbody>

            </table>

            {__tr(visas.length === 0 && <div className="p-6 text-center text-gray-500">
                {__tr(t("visa.No_visas_found"))}
              </div>)}

          </div>)}
      </div>
    </div>;
}
